const SERVER_URL = 'http://91.134.98.222';
  
export default SERVER_URL;
